import { languagesBP } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/useReferenceData'

const CODE_BY_LANGUAGE_NAME = new Map(languagesBP.map(({ id, value }) => [value.toLowerCase(), id]))

export const toRegistrationLanguageCode = (preferredLanguage?: string | null): string => {
  const name = (preferredLanguage || '').trim().toLowerCase()
  const nameWithoutRegion = name.split('-')[0].trim()

  return CODE_BY_LANGUAGE_NAME.get(name) || CODE_BY_LANGUAGE_NAME.get(nameWithoutRegion) || ''
}
